import React from 'react';
import propTypes from 'prop-types';
import { Routes, Route } from 'react-router-dom';
import { VendorsListPage } from './VendorsListPage';
import { VendorEditPageWrapper } from './VendorEditPageWrapper';

export function VendorsPage({ location, isExpanded }) {
  return (
    <Routes location={location}>
      <Route
        path="/"
        element={<VendorsListPage isExpanded={isExpanded} />}
      />
      <Route
        path="add"
        element={<VendorEditPageWrapper isExpanded={isExpanded} />}
      />
      <Route
        path="edit/:id"
        element={<VendorEditPageWrapper isExpanded={isExpanded} />}
      />
    </Routes>
  );
}

VendorsPage.propTypes = {
  location: propTypes.object.isRequired,
  isExpanded: propTypes.bool.isRequired,
};
